export const FRAMEWORK_QUERY = '/framework';
export const FRAMEWORK_DEFAULT_CONFIG_QUERY = '/framework/config/default';
export const FRAMEWORK_CONFIG_QUERY = '/framework/config/connection';
export const FRAMEWORK_REQUIREMENTS_QUERY = '/framework/requirements/connection';
export const COMBINED_FRAMEWORK_CONFIG_QUERY = '/framework/config/supplier';
export const FLEXIBLE_PREVIEW_QUERY = '/framework/flexible-preview';
